import React from 'react'
import { Select, Global } from '@mantine/core'

const SelectMantine = function ({ value, options, onChange }) {
  return (
    <div className="w-full flex flex-col">
      <Global
        styles={() => ({
          '.dark': {
            '.mantine-Select-input': {
              backgroundColor: 'unset',
              border: '1px solid var(--ow-color-darkTheme-800)',
              color: '#EAEDFF',
              fontSize: '14px',
            },
            '.mantine-Select-dropdown': {
              background: 'var(--ow-color-darkTheme-1100)',
              border: '1px solid var(--ow-color-darkTheme-800)',
            },
            '.mantine-Select-item': {
              color: '#EAEDFF',
              '&[data-selected]': {
                '&, &:hover': {
                  background: 'var(--ow-color-primary-700)',
                },
              },
              '&[data-hovered]': {
                background: 'var(--ow-color-darkTheme-900)',
              },
            },
          },
        })}
      />

      <Select
        styles={{
          dropdown: {
            borderStyle: 'solid',
          },
        }}
        onChange={onChange}
        value={value}
        data={options}
      />
    </div>
  )
}

export default SelectMantine
